module.exports = __webpack_public_path__ + "iconfont.ttf?318303f3626f8be22a20527e55597d29";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1513062955216
// module id = 18
// module chunks = 0